import clsx from "classnames";
import { Heading } from "@/ui/Heading";
import { DynamicText } from "@/ui/DynamicText";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import { useLocale } from "@/hooks/useLocale";
import UpcomingEventCard from "@/ui/UpcomingEventCard";
import { events_helper } from "@/helpers/events_helper";

export const EventsPageUpcomingEventsSection = ({ className, events, loading }) => {
  const locale = useLocale();

  return (
    <div className={clsx(className)}>
      <Container className="mb-md-5">
        <Heading className="mb-4">
          <DynamicText path={`page.events.section.upcoming.title.${locale}`} tag="h2" />
        </Heading>
        <Row>
          {loading ? (
            <div className="d-flex justify-content-center align-items-center p-5">
              <Spinner variant="primary" />
            </div>
          ) : (
            events.map((i) => (
              <Col key={i.id} xs={12} md={4} className="mb-4">
                <UpcomingEventCard item={i} />
              </Col>
            ))
          )}
        </Row>
      </Container>
    </div>
  );
};
